import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Jumbotron, Grid, Row, Col, Image, Button, ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import './Footer.css'

export default class Footer extends Component {

  render() {
    return (
      <div className="footer-container">
        <div className="footer-info">
          <ul>
            <li>
              <h4> Kundservice </h4>
              <p> idea@ilka.se </p>
              <p> 040 - 120012 </p>
            </li>
            <li>
              <Link to="/kontakt" className="footer-link">
                <h4> Kontakt </h4>
              </Link>
            </li>
            <li>
              <Link to="/integritet" className="footer-link">
                <h4> Integritet </h4>
              </Link>
            </li>
            <li>
              <h4> Press </h4>
            </li>
            <li>
              <h4>Laungage</h4>
              <ul className="laungage-menu">
                <li>Svenska</li>
                <li>Norsk</li>
                <li>English</li>
                <li>Deutsch</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="spacer"></div>

        <div className="footer-images">
          <Image src="images/forlagshusetwasa_krona.png"  className="loga-wasa"/>
          <Image src="images/ilkaloggavit.png"  className="loga-ilka"/>
        </div>

      </div>
    )
  }
}
